import { reactive, UnwrapRef } from 'vue'

export default function <T>() {
    const actions_state = reactive({
        is_actions_loading: false,
        is_actions_opened: false,
        is_create: false,
        is_update: false,
        is_delete: false,
        is_bind: false,
        initial_value: null as T | null,
    })

    const openActions = () => {
        actions_state.is_create = false
        actions_state.is_update = false
        actions_state.is_delete = false
        actions_state.is_bind = false
        actions_state.initial_value = null
        actions_state.is_actions_opened = true
    }

    const closeActions = () => {
        actions_state.is_create = false
        actions_state.is_update = false
        actions_state.is_delete = false
        actions_state.is_bind = false
        actions_state.is_actions_opened = false

        actions_state.initial_value = null
    }

    const startCreate = () => {
        openActions()
        actions_state.is_create = true
    }

    const startUpdate = (update_payload: UnwrapRef<T>) => {
        openActions()
        actions_state.initial_value = update_payload
        actions_state.is_update = true
    }

    const startDelete = (delete_payload: UnwrapRef<T>) => {
        openActions()
        actions_state.initial_value = delete_payload
        actions_state.is_delete = true
    }

    const startBind = (bind_payload: UnwrapRef<T>) => {
        openActions()
        actions_state.initial_value = bind_payload
        actions_state.is_bind = true
    }

    return { actions_state, startCreate, startUpdate, startDelete, startBind, closeActions }
}
